/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function getPermissions (params?: Record<string, any>): Promise<HalDocument<{
  permissions: Permission[]
}>> {
  return rest.get(`/api/permissions?${stringify(params)}`)
    .then((resp) => resp.json())
}
